import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';

import { MainComponent } from './sections/main/main.component';
import { AboutUsComponent } from './sections/aboutus/aboutus.component';
import { IdeaVisionComponent } from './sections/idea-and-vision/idea-vision.component';
import { CustomersComponent } from './sections/customers/customers.component';
import { ActivitiesComponent } from './sections/activities/activities.component';
import { ContactUsComponent } from './sections/contact-us/contact-us.component';

@NgModule({
  declarations: [
    AppComponent,

    MainComponent,
    AboutUsComponent,
    IdeaVisionComponent,
    CustomersComponent,
    ActivitiesComponent,
    ContactUsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,

    //import Material modules
    MatCardModule,
    MatButtonModule,
    MatDividerModule,
    MatGridListModule,
    MatListModule,
    MatSidenavModule,
    MatToolbarModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
